import React, { useState, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { FilledButton, TextButton } from './Button';
import { OutlinedButton } from './Button';

type LightboxProps = {
    content: ReactNode;
    header?: string;

    confirmText?: string;
    cancelText?: string;
    thirdActionText?: string;
    deleteText?: string;
    confirmTheme?: 'primary' | 'danger';

    loadingConfirm?: boolean;
    loadingCancel?: boolean;
    loadingThirdAction?: boolean;
    loadingDelete?: boolean;

    disabledConfirm?: boolean;
    disabledThirdAction?: boolean;
    disabledDelete?: boolean;

    onClose: () => void;
    onConfirm?: () => void;
    onCancel?: () => void;
    onThirdAction?: () => void;
    onDelete?: () => void;
};

const Lightbox: React.FC<LightboxProps> = ({ content, onClose, header, confirmText, cancelText, thirdActionText, deleteText, loadingConfirm, loadingCancel, loadingThirdAction, loadingDelete, onConfirm, onCancel, onThirdAction, onDelete, disabledConfirm, disabledThirdAction, disabledDelete, confirmTheme }) => {
    const handleBackgroundClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 backdrop-blur-sm bg-black/50 flex justify-center items-center z-10"
            onClick={handleBackgroundClick}
        >
            <div
                className="relative bg-white p-6 border border-neutral-300 rounded-xl shadow-lg max-w-xl md:max-w-[60vw] w-full max-h-[75vh] overflow-y-auto"
            >
                {header && <h2 className="text-lg font-bold mb-4">{header}</h2>}
                <div>{content}</div>
                <div className="mt-6 flex flex-row w-full space-x-2 items-center">
                    {onThirdAction && <TextButton onClick={onThirdAction} isLoading={loadingThirdAction} disabled={disabledThirdAction}>{thirdActionText || 'Action'}</TextButton>}
                    <div className="flex-1" />
                    {onCancel && <OutlinedButton onClick={onCancel} isLoading={loadingCancel}>{cancelText || 'Cancel'}</OutlinedButton>}
                    {onConfirm && <FilledButton onClick={onConfirm} isLoading={loadingConfirm} disabled={disabledConfirm} theme={confirmTheme}>{confirmText || 'Confirm'}</FilledButton>}
                    {onDelete && <FilledButton onClick={onDelete} isLoading={loadingDelete} disabled={disabledDelete} theme='danger'>{deleteText || 'Delete'}</FilledButton>}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Lightbox;